import { apiAxios } from './apiConfig';

/**
 * 카카오톡 "나에게 보내기" 관리자 알림(신규가입/입금요청/입금완료) 최초 연동용 API.
 * 백엔드 KakaoMemoAdminController 참고. 카카오 콘솔의 redirect_uri 신규 등록란이
 * 일시적으로 노출되지 않는 문제로, 기존 로그인용 redirect_uri를 재사용한다
 * (KakaoCallback.tsx가 state 접두사로 이 흐름을 구분해 전달).
 */
export const adminKakaoMemoApi = {
  getAuthorizeUrl: async (): Promise<string> => {
    const response = await apiAxios.get('/admin/kakao-memo/authorize-url');
    return response.data.authorizeUrl;
  },
  submitCallback: async (code: string, state: string): Promise<void> => {
    await apiAxios.post('/admin/kakao-memo/callback', { code, state });
  },
};
